__turbopack_context__.v({
  "container": "styles-module__49FJGq__container",
  "input": "styles-module__49FJGq__input",
});
